import { Table } from 'antd';
import React from 'react';
import { tableComponents } from '../../constants/tableComponents';

const DataTable = ({
  pagination = true,
  dataSource = [],
  columns = [],
  onChange,
  paginationBlock,
  rowKey = 'id',
  ...props
}) => {
  return (
    <>
      <Table
        {...props}
        dataSource={dataSource}
        rowKey={rowKey}
        pagination={false}
        columns={columns}
        onChange={onChange}
        components={tableComponents}
      />
      {paginationBlock && paginationBlock}
    </>
  );
};

export default DataTable;
